/* eslint-disable max-len */
/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import ProductService from "../../../services/ProductService";
import ToastService from "../../../services/ToastService";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useLocation, useHistory } from "react-router-dom";

const AdminProductDetails = () => {
  const [remark, setRemark] = useState("");
  const [productDetails, setProductDetails] = useState({});
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [pdfdownload, setPdfDownload] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(location.search);
  const productId = query.get("id");

  useEffect(() => {
    const path = location.pathname;
    setButtonDisabled(['/country-product-details', '/product-practitioner-details'].includes(path));
    getProductById(productId);
  }, [productId, location.pathname]);

  const getProductById = async (id) => {
    try {
      const result = await ProductService.getProductById({ p: id });
      if (result) {
        setProductDetails(result[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onApproveDisapproveProduct = async (status) => {
    const data = {
      ID: productId,
      post_status: status,
    };

    try {
      const result = await ProductService.updateStatus(data);
      if (result.data === 200) {
        ToastService.success(result.data.message);
      } else {
        ToastService.error(result.data.message);
      }
      history.goBack();
    } catch (err) {
      console.error(err);
    }
  };

  const downloadPdfDocument = () => {
    setPdfDownload(true);
    const input = document.getElementById("testId");
    html2canvas(input, { useCORS: true }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", [canvas.width, canvas.height]);

      pdf.addImage(
        imgData,
        "JPEG",
        30,
        30,
        canvas.width - 60,
        canvas.height - 60,
      );

      pdf.save("ProductDetail.pdf");
    });
  };

  return (
    <div className="container pt-2">
      {buttonDisabled ? (
        <h4>Product Details</h4>
      ) : (
        <div className="row bg-body-secondary p-3 mt-3 rounded rounded-2">
          <div className="col-md-8 head-title">
            <h4>{productDetails.post_status === 'pending' ? 'Approve' : 'Disapprove'} Product</h4>
          </div>
          <div className="col-md-4 group-btn text-end">
            {productDetails.post_status === 'pending' ? (
              <button
                type="button"
                className="btn theme-btn-fill"
                onClick={() => onApproveDisapproveProduct("publish")}
              >
                Approve
              </button>
            ) : (
              <button
                type="button"
                className="btn theme-btn-outline"
                onClick={() => onApproveDisapproveProduct("pending")}
              >
                Disapprove
              </button>
            )}
          </div>
          <hr className="mt-4"></hr>
          <div className="col-12">
            <div className="form-group mb-4 position-relative">
              <textarea
                className="form-control textarea-height"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                name="anycomment"
                rows="3"
                placeholder="Write Comments here"
              />
            </div>
          </div>
        </div>
      )}
      <div id="testId">
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="box-zoom">
              <div className="product-images">
                <div className="picZoomer">
                  <img
                    src={
                      productDetails?.product_image?.length > 0 &&
                      productDetails?.product_image[0]
                    }
                    className="img-fluid my_img"
                    alt="gallery"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <h5>{productDetails.post_title}</h5>
            <span className="badge rounded-pill text-bg-morelight fw-normal mt-4">
              Ayush’s Pick
            </span>
            <h4 className="mt-4 text-dark">{productDetails.post_title}</h4>
            <p className="mt-4 text-dark">
              <b>About this product :</b> {productDetails.post_content}
            </p>
            <div className="mt-4 p-des">
              <p className="fs-3 fw-bold text-dark mb-0 pb-0">
                <i className="fa fa-inr" aria-hidden="true" /> {productDetails.product_price}
              </p>
              <span className="mt-2 d-block">
                Local taxes included (where applicable)
              </span>
              {(productDetails.link_one || productDetails.link_two || productDetails.link_two) && <span className="mt-4 d-block text-dark fw-bold">
                Buy online below...
              </span>}
              <div className="d-flex gap-2 mt-2">
                {productDetails.link_one && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={productDetails.link_one}
                    className="btn btn-link"
                  >
                    <i className="fa fa-link" aria-hidden="true" /> {productDetails.link_one}
                  </a>
                )}
                {productDetails.link_two && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={productDetails.link_two}
                    className="btn btn-link p-2"
                  >
                    <i className="fa fa-link" aria-hidden="true" /> {productDetails.link_two}
                  </a>
                )}
                {productDetails.link_three && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={productDetails.link_three}
                    className="btn btn-link p-2"
                  >
                    <i className="fa fa-link" aria-hidden="true" /> {productDetails.link_three}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        {(productDetails.product_effective || productDetails.ingredient) && <div className="row mt-4 my-4 bg-dark-subtle highlighted-row p-3 rounded rounded-4">
          {productDetails.product_effective && <div className="col-md-6 border-end border-4 border-white px-4">
            <b>Product Effective for...</b>
            <p className="d-block mt-2">{productDetails.product_effective}</p>
          </div>}
          {productDetails.ingredient && <div className="col-md-6 px-4">
            <b>Main Ingredients...</b>
            <p className="d-block mt-2">{productDetails.ingredient}</p>
          </div>}
        </div>}
        <div className="row">
          <div className="col-12">
            {productDetails.short_description && <p>
              <b>Product Description</b>
              <span className="mt-2 d-block">
                {productDetails.short_description}
              </span>
            </p>}
            {productDetails.legal && <p>
              <b>Legal Disclaimer</b>
              <span className="mt-2 d-block">{productDetails.legal}</span>
            </p>}
            <p>
              <b>Product Technical Details</b>
              <hr />
            </p>
            <table className="table product-des-table">
              <thead>
                {productDetails?.category?.length > 0 && <tr>
                  <th width="30%">Domain</th>
                  <td>

                    {productDetails?.category[0]?.name}
                  </td>
                </tr>}
              </thead>
              <tbody>
                {productDetails.weight && <tr>
                  <th>Weight</th>
                  <td>{productDetails.weight}</td>
                </tr>}
                {productDetails.brand && <tr>
                  <th>Brand</th>
                  <td>{productDetails.brand}</td>
                </tr>}
                {productDetails.quantity && <tr>
                  <th>Item Package Quantity</th>
                  <td>{productDetails.quantity}</td>
                </tr>}
                {productDetails.form && <tr>
                  <th>Form</th>
                  <td>{productDetails.form === 1 ? "Solid" : "Liquid"}</td>
                </tr>}
                <tr>
                  <th>Country Of Origin</th>
                  <td>{productDetails.country?.blogname}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="dwnbtnoutr">
        <button
          type="button"
          className="card-link rounded rounded-2 btntxdsh darkbtn"
          onClick={downloadPdfDocument}
        >
          Download Product Details
        </button>
      </div>
    </div>
  );
};

export default AdminProductDetails;
